module.exports = __webpack_public_path__ + "static/media/sound.10d1ae0f.svg";